export default __webpack_public_path__ + "static/media/logouthover.edff0cbd.svg";